import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styled from 'styled-components'

const Icon = styled.i`
  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};
  margin-top: auto;
`

const ReorderButton = ({ disabled, onClick, icon, 'data-testid': dataTestId }) => (
  <Icon
    disabled={disabled}
    onClick={!disabled ? onClick : null}
    className={classNames('icon link m0', disabled ? 'text-grey-lighter' : 'grey', icon)}
    data-testid={dataTestId}
  />
)

ReorderButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  'data-testid': PropTypes.string,
}

const ReorderWrapper = styled.div`
  position: absolute;
  height: 32px;
  top: -32px;
  left: 0;
  right: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
  &::before,
  &::after {
    content: '';
  }
`

export const ReorderButtons = ({ children }) => {
  return <ReorderWrapper>{children}</ReorderWrapper>
}

ReorderButtons.Button = ReorderButton
ReorderButtons.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ReorderButtons/index.js